import React, { useEffect } from 'react'
import './App.css'
import Routes from './Routes'
import { useDispatch, useSelector } from 'react-redux'
import { SnackbarProvider } from 'notistack'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import SnackbarComponent from './components/Snackbar/SnackbarComponent'
import { makeSelectToken, makeSelectUser } from './store/auth/selectors'
import { supabase } from './supabaseClient'
import { fetchAuthenticatedUser, login, setToken } from './store/auth/actions'
import Loader from './containers/Loader'
import { setItem } from './utils/localStorage'

function App() {
  const dispatch = useDispatch()

  const token = useSelector(makeSelectToken())
  const user = useSelector(makeSelectUser())

  useEffect(() => {
    supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        dispatch(setToken(session.access_token))
        setItem('token', session.access_token)
        dispatch(login())
      } else {
        dispatch(setToken(null))
      }
    })
  }, [])
  useEffect(() => {
    if (token) {
      dispatch(fetchAuthenticatedUser())
    }
  }, [token, dispatch])
  return (
    <HelmetProvider>
      <SnackbarProvider>
        <Helmet>
          <title>AvoSquado</title>
        </Helmet>
        <div className="App">{token && !user ? <Loader /> : <Routes user={user} />}</div>
        <SnackbarComponent />
      </SnackbarProvider>
    </HelmetProvider>
  )
}

export default App
